import * as PropTypes from "../prop-types";
import { Position, SpsActionMethod } from "@spscommerce/ds-shared";
import { Eventually } from "@spscommerce/utils";

export const spsOptionListPassthroughProps = {
    docs: {
        options: "Eventually<any[]> | (filter?: string) => Eventually<any[]>",
        captionKey: "string",
        comparisonKey: "string",
        textKey: "string",
        valueKey: "string",
        zeroState: "string",
    },
    propTypes: {
        captionKey: PropTypes.string,
        comparisonKey: PropTypes.string,
        options: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.instanceOf<Promise<any[]>>(Promise),
            PropTypes.fun<(filter?: string) => Eventually<any[]>>(),
        ]).isRequired,
        textKey: PropTypes.string,
        valueKey: PropTypes.string,
        zeroState: PropTypes.string,
    }
};

export const searchableOptionListProps = {
    hideInlineSearch: PropTypes.bool,
    onSearchChange: PropTypes.fun<React.ChangeEventHandler>(),
    search: PropTypes.string,
    searchDebounce: PropTypes.number,
    searchPlaceholder: PropTypes.string,
};

export const propTypes = {
    ...PropTypes.spsGlobalPropTypes,
    ...spsOptionListPassthroughProps.propTypes,
    ...searchableOptionListProps,
    attachTo: PropTypes.ref<HTMLElement>().isRequired,
    conformWidth: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
    keyDown: PropTypes.impl<React.KeyboardEvent>(),
    nullOption: PropTypes.string,
    offsets: PropTypes.arrayOf(PropTypes.number),
    onOptionListChanged: PropTypes.fun<(filteredListLength: number) => void>(),
    onOptionSelected: PropTypes.fun<(option) => void>(),
    onPositionFlip: PropTypes.fun<(opensUpward: boolean) => void>(),
    onSelfToggle: PropTypes.fun<(isOpen: boolean) => void>(),
    optionRole: PropTypes.string,
    positionOverride: PropTypes.arrayOf(PropTypes.enumValue<Position>(Position)),
    selectedOption: PropTypes.any,
    specialAction: PropTypes.fun<SpsActionMethod>(),
};

export type SpsOptionListProps = PropTypes.InferTS<typeof propTypes, HTMLDivElement>;
